class SitePrint {
    
    private readonly _address : string = "http://127.0.0.1:9100/"
    
    private async GetDefault() {
        let response = await new QueryRequest(`${this._address}default?type=printer`)
            .request();
        
        let json = await response.json();
        json.version = 2;
        json.readRetries = json.connection == "bluetooth" ? 1 : 0;
        return json;
    }
    
    public async PrintRequest(request: IActionLink) {
        let response = await new QueryRequest(
            SiteAction.toLink(request.actionInfo),
            request.model ?
                {
                    contentType: 'json',
                    data: request.model,
                    method: 'post'
                }
                : {
                    contentType: 'json',
                    method: 'get'
                }
        ).request();
        
        return await this.PrintBlob(await response.blob());
    }
    
    public async PrintBlob(blob: Blob) {
        let form = new FormData();
        let json = await this.GetDefault();
        form.append("json", JSON.stringify({
            device: json
        }));
        form.append("blob", blob);

        let request = new QueryRequest(`${this._address}write`, {
            method: "post",
            contentType: "form",
            data: form
        });
        let response = await request.request();
        //let json = await response.json();
    }
}